import type { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';
import { ButtonLogout } from 'components/button/buttonLogout';
import { LanguageSelector } from 'components/language/LanguageSelector';
import { LogoUnderline } from 'components/logo/LogoUnderline';

import { HeaderMethodSelectorButton } from './components/HeaderMethodSelectorButton';
import { Logo } from '../../images/Logo';
import { logoLanguage } from '../../util/lang';

export const Header = ({ children }: PropsWithChildren) => (
  <Flex bg='white' borderRadius='3xl' p={10} gap={8} mb={3.5} width='100%'>
    <Flex alignItems='center' justifyContent='space-between' width='100%' gap={8}>
      <Flex gap={8} alignItems='center'>
        <Link to='/'>
          <Logo lang={logoLanguage} />
        </Link>
        <LogoUnderline vertical />
        <HeaderMethodSelectorButton />
      </Flex>
      <Flex gap={4} flexShrink={0}>
        <ButtonLogout />
        <LanguageSelector />
      </Flex>
    </Flex>
    {children}
  </Flex>
);
